// Import the functions you need from the SDKs you need
// pls do not touch

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCCgwcVAY08T8QyVXdXmQESHaguUuiFiH8",
  authDomain: "info442-43f98.firebaseapp.com",
  projectId: "info442-43f98",
  storageBucket: "info442-43f98.firebasestorage.app",
  messagingSenderId: "606448287090",
  appId: "1:606448287090:web:f2dc3cdd0fe1273413f1eb",
  measurementId: "G-X9KTP91JEF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;